exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.box-card[data-v-1fe8cabe],\n.table[data-v-1fe8cabe],\n.pag[data-v-1fe8cabe] {\n  margin-top: 20px;\n}\n.el-col .el-button[data-v-1fe8cabe]:nth-child(1),\n.el-col .el-button[data-v-1fe8cabe]:nth-child(2) {\n  padding: 10px 14px;\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/sunpay-system-manager/src/components/clientmanage/index.vue"],"names":[],"mappings":";AACA;;;EAGE,iBAAiB;CAClB;AACD;;EAEE,mBAAmB;CACpB","file":"index.vue","sourcesContent":["\n.box-card[data-v-1fe8cabe],\n.table[data-v-1fe8cabe],\n.pag[data-v-1fe8cabe] {\n  margin-top: 20px;\n}\n.el-col .el-button[data-v-1fe8cabe]:nth-child(1),\n.el-col .el-button[data-v-1fe8cabe]:nth-child(2) {\n  padding: 10px 14px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1fe8cabe","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/clientmanage/index.vue
// module id = y6v/
// module chunks = 8